import { default as AsyncDialogComponent } from "./AsyncDialog.vue"; /**
 * This component isn't really needed anymore and has a really confusing interface.
 * Just use a regular html dialog element with the DialogLayout component.
 * @deprecated
 */
export const AsyncDialog = AsyncDialogComponent;
export { default as ConfirmDialog } from "./ConfirmDialog.vue";
export { default as ConfirmDialogContent } from "./ConfirmDialogContent.vue";
export { setConfirmComponent } from "./confirm-options";
